module.exports = __webpack_public_path__ + "img/lgoin_bg.95289fdc.png";